import { render, staticRenderFns } from "./SurveyQuestionCreateNUpdate.vue?vue&type=template&id=b7666ad4"
import script from "./SurveyQuestionCreateNUpdate.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionCreateNUpdate.vue?vue&type=script&lang=js"
import style0 from "./SurveyQuestionCreateNUpdate.vue?vue&type=style&index=0&id=b7666ad4&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7666ad4')) {
      api.createRecord('b7666ad4', component.options)
    } else {
      api.reload('b7666ad4', component.options)
    }
    module.hot.accept("./SurveyQuestionCreateNUpdate.vue?vue&type=template&id=b7666ad4", function () {
      api.rerender('b7666ad4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/SurveyQuestionCreateNUpdate.vue"
export default component.exports